import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 11 17" {...props}>
      <title>{props.title || 'Sort order'}</title>

      <g>
        <polygon
          fill="#FFFFFF"
          points="4.1,17.3 -0.7,12.5 0.7,11.1 2.1,12.5 2.1,0 4.1,0"
        />
        <polygon
          fill="#B3B3B3"
          points="8.3,16.8 6.3,16.8 6.3,-0.6 11.2,4.3 9.7,5.7 8.3,4.3"
        />
      </g>
    </Icon>
  )
}
